module.exports = __webpack_public_path__ + "img/qian_finished.f6ccfa41.svg";